module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/wristwatch-8a7a088c0d7da7237d2a387b7a7a0755.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/wristwatch.svg
// module id = JeXC
// module chunks = 24